import React, {useEffect} from 'react';
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import {userPages, userPagesIcons} from "../userNavItem/UserNavItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {Trans, useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid2";
import {CardContent} from "@mui/material";
import {Link, useNavigate, useParams} from "react-router";
import MyOrders from "./pages/MyOrders";
import MyAddresses from "./pages/MyAddresses";
import MyBillingInfo from "./pages/MyBillingInfo";
import MyDesigns from "./pages/MyDesigns";
import {useUser} from "../../managers/userManager/userManager";

const pages = {
    orders: <MyOrders/>,
    'saved-addresses': <MyAddresses/>,
    'billing-info': <MyBillingInfo/>,
    'designs': <MyDesigns/>
}


function UserPage(props) {
    const {page} = useParams();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const user = useUser();

    useEffect(() => {
        if (user && user.noUser && navigate) {
            navigate('/sign-in')
        }
    }, [user, navigate])

    return (
        <Container maxWidth="md" id={'user-page'} sx={{pt: {xs: 0, md: 4}}}>
            <Grid container flexDirection={'row'}>
                <Grid size={{md: 4, xs: 0}} sx={{display: {md: 'block', xs: 'none'}}}><List>
                    {userPages.map((text) => (
                        <Link to={`/user/${text}`} key={text}
                              style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem key={text} disablePadding>
                                <ListItemButton selected={page === text}>
                                    <ListItemIcon>
                                        {userPagesIcons[text]}
                                    </ListItemIcon>
                                    <ListItemText primary={<Trans i18nKey={`header.userMenu.${text}`}/>}/>
                                </ListItemButton>
                            </ListItem>
                        </Link>
                    ))}
                </List></Grid>
                <Grid size={{md: 0, xs: 12}}><List  sx={{display: {md: 'none', xs: 'flex'}}}>
                    {userPages.map((text) => (
                        <Link to={`/user/${text}`} key={text}
                              style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem key={text} disablePadding>
                                <ListItemButton selected={page === text}>
                                    <ListItemIcon sx={{display:'flex', justifyContent: 'center'}}>
                                        {userPagesIcons[text]}
                                    </ListItemIcon>
                                </ListItemButton>
                            </ListItem>
                        </Link>
                    ))}
                </List></Grid>
                <Grid size={{md: 8, xs: 12}}>
                    <CardContent key={t('header.Home')}>{pages[page]}</CardContent>
                </Grid>
            </Grid>
        </Container>
    );
}

export default UserPage;
